import { injectable } from "inversify";
import SedeEntity from "../../entities/SedeEntity";
import SedeProvider from "../../providers/sede/SedeProvider";
import SedeRepository from "../../repositories/SedeRepository";

interface props {
    sedeRepository: SedeRepository;
    sedeProvider: SedeProvider;
}

@injectable()
export default class GetAllSedesUseCase {
    _sedeRepository: SedeRepository;
    _sedeProvider: SedeProvider;

    constructor(_: props) {
        this._sedeRepository = _.sedeRepository;
        this._sedeProvider = _.sedeProvider;
    }

    async call(): Promise<SedeEntity[]> {
        try {
            const response = await this._sedeRepository.getAll();
            this._sedeProvider.Actions.setSedes(response);
            return response;
        } catch (error) {
            throw error;
        }
    }
}

export const GetAllSedesUseCaseName = "GetAllSedesUseCaseName";
